import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

import { SharedUiInfoDialogComponent } from '../shared-ui-info-dialog/shared-ui-info-dialog.component';

type InfoIcon = 'info-thick' | 'info-thin';

@Component({
  selector: 'enx-shared-ui-info-icon',
  standalone: true,
  imports: [CommonModule, MatTooltipModule, MatIconModule],
  templateUrl: './shared-ui-info-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      :host {
        @apply flex;
      }
    `,
  ],
})
export class SharedUiInfoIconComponent {
  tooltip = input.required<string>();
  icon = input.required<InfoIcon>();
  header = input<string>('');
  hasTooltip = input<boolean>(true);

  constructor(public dialog: MatDialog) {}

  open(e: Event): void {
    if (this.hasTooltip()) {
      return;
    }

    e.stopPropagation();
    const windowHeight = window.innerHeight;
    const topOffset = `${windowHeight / 6}px`;

    this.dialog.open(SharedUiInfoDialogComponent, {
      data: {
        header: this.header(),
        content: this.tooltip(),
      },
      panelClass: 'enx-info-dialog',
      position: {
        top: topOffset,
      },
    });
  }
}
